
var stringUtil = require("../string/stringUtil");
var stateManager = require('../state/stateManager.js');

var defaultAppConfig = require('./config.js').getConfig();

var defaultAccountSettings = require('../../accounts/settings');
var amigosSettings = require('../../accounts/amigos/settings');
var mergedAccountSettings = null;

export function getAppConfig()
{
    return defaultAppConfig;
}

export async function loadConfiguration()
{
    await updateEnvironment();

    if (stringUtil.isStringNullOrEmpty(defaultAppConfig.environmentConfigServiceUrl))
        return;

    var requestBody = {};
    requestBody.method = 'GET';
    var response = await fetch(defaultAppConfig.environmentConfigServiceUrl, requestBody);
    if (response.status != 200)
        throw `Error occurred while loading configuration with status: ${response.status} `;

    var configurationsResponse = await response.json();
    if (!configurationsResponse.found)
        return;

    
    var remoteConfigurations = configurationsResponse.configurations;
    for(var property in defaultAppConfig)
    {
        if (stringUtil.areStringSame(property, "environment") || stringUtil.areStringSame(property, "environmentConfigServiceUrl") ||
            stringUtil.areStringSame(property, "version"))
            continue;
            
        if (!remoteConfigurations.hasOwnProperty(property))
            throw `Failed to find configuration for environment: ${defaultAppConfig.environment} with key: ${property}`
        
            defaultAppConfig[property] = remoteConfigurations[property];
    }
}

async function updateEnvironment()
{
    var completeUrl = `/environment.json`;

    let response = await fetch(completeUrl, {cache: "no-store"});
    if (response.status != 200)
    {
        var errorMessage = `Error occurred while loading environment configuration. The returned code is ${response.status}`;
        throw errorMessage;
    }

    var environmentConfiguration = await response.json();
    getAppConfig().environment = environmentConfiguration.environment;
    getAppConfig().environmentConfigServiceUrl = environmentConfiguration.environmentConfigServiceUrl;
}

export function getAccountSettings()
{
    if (mergedAccountSettings != null)
        return mergedAccountSettings;


    var allAccountSettings = getAllAccountSettings();
    var state = stateManager.getStore().getState();
    var accountSetting = allAccountSettings.find(s => stringUtil.areStringSame(s.applicationId, state.applicationId));

    if (accountSetting == null)
    {
        mergedAccountSettings = defaultAccountSettings.getConfig();
    }
    else
    {
        mergedAccountSettings = Object.assign({}, defaultAccountSettings.getConfig(), accountSetting.getConfig());
    }

    return mergedAccountSettings;
}

function getAllAccountSettings()
{
    var allAccountSettings = [];
    allAccountSettings.push(amigosSettings);
    //Add other account related settings
    return allAccountSettings;
}